/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    labels: {
        finishDate: "Fin",
        formatPlaceholder: "JJ/MM/AAAA",
        startDate: "Début"
    }
};